import AuditPlannerController from "PFApp/audit_planner/audit_planner_controller";
import NotFoundRoute from "PFApp/routes/not_found_route";
import {
  EnsureAuditPlannerPermission,
  EnsureLoggedIn,
  EnsureRegistrationComplete,
  WithLayout
} from "PFApp/routes/route_helpers";
import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";

const AuditPlannerRoutes = () => {
  const { path } = useRouteMatch();

  return (
    <EnsureLoggedIn>
      <EnsureRegistrationComplete>
        <EnsureAuditPlannerPermission>
          <WithLayout>
            <Switch>
              <Route path={`${path}/:section?/:engagementId?/:roleId?/:tab?`}>
                <AuditPlannerController />
              </Route>
              <Route path="*">
                <NotFoundRoute />
              </Route>
            </Switch>
          </WithLayout>
        </EnsureAuditPlannerPermission>
      </EnsureRegistrationComplete>
    </EnsureLoggedIn>
  );
};

export default AuditPlannerRoutes;
